export default __webpack_public_path__ + "static/media/KHYT.3dbdff54.png";